/**
 * Ctextinput Component
 * Text input component with multiple states and dropdown mode
 */
'use client';
import { Cdropdown } from '../Cdropdown';
import { CTEXTINPUT_DROPDOWN_ALIGN_CENTER, CTEXTINPUT_DROPDOWN_OPEN_DIRECTION_AUTO, CtextinputDataName, DROPDOWN_MAX_HEIGHT_PX, DROPDOWN_WIDTH_PX, } from './Ctextinput.constants';
import { CtextinputBody } from './CtextinputBody';
import { CtextinputLabel } from './CtextinputLabel';
import { TextInputMode, type CtextinputProps } from './Ctextinput.types';
import { getCtextinputViewModel } from './Ctextinput.view-model';
import { useCtextinputInteractions } from './useCtextinputInteractions';
const CTEXTINPUT_VALUE = "Ctextinput";
export { TextInputMode } from './Ctextinput.types';
export type { CtextinputProps } from './Ctextinput.types';
export function Ctextinput({ value, onChange, placeholder = '', label, id, name, rows = 1, errorText, isError: isErrorProp = false, disabled = false, mode = TextInputMode.Textual, availableOptions = [], radius, paddingRight, padding, backgroundColor, backgroundOpacity, borderColor, borderOpacity, borderWidth, innerBorder, boxShadow, height, textAlign, fontSize, inputContentStyle, inputElementStyle, autoFocus = false, onFocus, onBlur, onKeyDown, onScroll, className, style, }: CtextinputProps): React.JSX.Element {
    const interactions = useCtextinputInteractions({
        availableOptions,
        disabled,
        mode,
        onBlur,
        onChange,
        onFocus,
    });
    const viewModel = getCtextinputViewModel({
        customWrapperStyle: style,
        disabled,
        errorText,
        fontSize,
        inputContentStyle,
        inputElementStyle,
        isDropdownOpen: interactions.isDropdownOpen,
        isErrorProp,
        isFocused: interactions.isFocused,
        label,
        mode,
        padding,
        paddingRight,
        placeholder,
        rows,
        textAlign,
        value,
    });
    const inputBody = (<CtextinputBody autoFocus={autoFocus} backgroundColor={backgroundColor} backgroundOpacity={backgroundOpacity} borderColor={borderColor} borderOpacity={borderOpacity} borderWidth={borderWidth} boxShadow={boxShadow} disabled={disabled} height={height} id={id} innerBorder={innerBorder} inputRef={interactions.inputRef} name={name} onContainerClick={interactions.handleContainerClick} onInputBlur={interactions.handleBlur} onInputChange={interactions.handleInputChange} onInputFocus={interactions.handleFocus} onKeyDown={onKeyDown} onScroll={onScroll} placeholder={placeholder} radius={radius} rows={rows} value={value} viewModel={viewModel}/>);
    return (
    <div className={className} style={viewModel.styles.wrapperStyle}>
      {label && <CtextinputLabel label={label}/>}

      {viewModel.isDropdownMode ? (<Cdropdown dataElScope="Ctextinput/OptionsDropdown" trigger={inputBody} options={interactions.dropdownOptions} isOpen={interactions.isDropdownOpen} onOpenChange={interactions.setIsDropdownOpen} width={DROPDOWN_WIDTH_PX} maxHeight={DROPDOWN_MAX_HEIGHT_PX} align={CTEXTINPUT_DROPDOWN_ALIGN_CENTER} openDirection={CTEXTINPUT_DROPDOWN_OPEN_DIRECTION_AUTO} selectedKey={viewModel.selectedKey} keyboardNavigation closeOnSelect dismissOnOutsideClick triggerDisabled={disabled} triggerFullWidth/>) : inputBody}
    </div>
    );
}
